export default __webpack_public_path__ + "static/deel_splash-05d14acc030f358c4a71116ba14bf7ce.png";